module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "internalUserInfo"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h3', [_vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name) + " - " + _vm._s(_vm.user.dob) + " (" + _vm._s(_vm.user.email) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('CommsLogs', {
    attrs: {
      "comms_url": _vm.comms_url,
      "logs_url": _vm.logs_url,
      "comms_add_url": "test"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "pills-tabContent"
    }
  }, [_c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-details",
      "role": "tabpanel",
      "aria-labelledby": "pills-details-tab"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Personal Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.pdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "true",
      "aria-controls": _vm.pdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.pdBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "personal_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Account Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    ref: "dob",
    staticClass: "input-group date",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.dob),
      expression: "user.dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.user.dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "dob", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Given Name(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.legal_first_name),
      expression: "user.legal_first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "first_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.legal_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "legal_first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Last Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.legal_last_name),
      expression: "user.legal_last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "last_name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.legal_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "legal_last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Verified Date of Birth")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    ref: "dob",
    staticClass: "input-group date",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.legal_dob),
      expression: "user.legal_dob"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text",
      "name": "dob",
      "placeholder": "DD/MM/YYYY"
    },
    domProps: {
      "value": (_vm.user.legal_dob)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "legal_dob", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('b', [_vm._v("To update this account please "), _c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "target": "_blank",
      "href": _vm.user.acc_mgmt_url
    }
  }, [_vm._v("click here")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Identification\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.idBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.idBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.idBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "id_form",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [(_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_c('SecureBaseLink', {
    attrs: {
      "link_name": "Uploaded Photo ID",
      "link_data": {
        'customer_id': _vm.user.id
      }
    }
  })], 1) : (!_vm.uploadedID) ? _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v("Attach Photo ID"), _c('input', {
    ref: "uploadedID",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.readFileID()
      }
    }
  })]) : _c('span', {
    staticClass: "col-sm-3 btn btn-link btn-file pull-left"
  }, [_vm._v(" Uploading...")]), _vm._v(" "), (_vm.uploadedID) ? _c('span', {
    staticClass: "btn btn-link btn-file pull-left"
  }, [_c('a', {
    staticClass: "fa fa-trash-o",
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    attrs: {
      "title": "Remove file"
    },
    on: {
      "click": function($event) {
        return _vm.removeID()
      }
    }
  })]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Address Details\n                                    "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.adBody,
      "data-toggle": "collapse",
      "expanded": "false",
      "data-parent": "#userInfo",
      "aria-controls": _vm.adBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), (_vm.loading.length == 0) ? _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.adBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Street")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.line1),
      expression: "user.residential_address.line1"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "street",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.line1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "line1", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Town/Suburb")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.locality),
      expression: "user.residential_address.locality"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "surburb",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.locality)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "locality", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.state),
      expression: "user.residential_address.state"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "country",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.postcode),
      expression: "user.residential_address.postcode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "postcode",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.residential_address.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user.residential_address, "postcode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.residential_address.country),
      expression: "user.residential_address.country"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user.residential_address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(c) {
    return _c('option', {
      key: c.code,
      domProps: {
        "value": c.code
      }
    }, [_vm._v(_vm._s(c.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingAddress) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateAddress()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Contact Details "), _c('small'), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.cdBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.cdBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.cdBody
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "index.html",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone_number),
      expression: "user.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.mobile_number),
      expression: "user.mobile_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.mobile_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "mobile_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "disabled": "disabled",
      "name": "email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.updatingContact) ? _c('button', {
    staticClass: "pull-right btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateContact()
      }
    }
  }, [_vm._v("Update")]) : _c('button', {
    staticClass: "pull-right btn btn-primary",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }), _vm._v(" Updating")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Organisations "), _c('small'), _vm._v(" "), _c('a', {
    staticClass: "panelClicker",
    attrs: {
      "href": '#' + _vm.odBody,
      "data-toggle": "collapse",
      "data-parent": "#userInfo",
      "expanded": "false",
      "aria-controls": _vm.odBody
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up pull-right "
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body collapse in",
    attrs: {
      "id": _vm.odBody
    }
  }, [_vm._l((_vm.user.wildlifecompliance_organisations), function(org) {
    return _c('div', {
      key: org.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.name),
        expression: "org.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (org.abn),
        expression: "org.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (org.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(org, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "text-decoration": "none"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.unlinkUser(org)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-chain-broken fa-2x"
    }), _vm._v(" Unlink")])])])
  }), _vm._v(" "), _vm._l((_vm.orgRequest_pending), function(orgReq) {
    return _c('div', {
      key: orgReq.id
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("Organisation")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.name),
        expression: "orgReq.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', {
      staticClass: "col-sm-2 control-label",
      attrs: {
        "for": ""
      }
    }, [_vm._v("ABN/ACN")]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-3"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (orgReq.abn),
        expression: "orgReq.abn"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "disabled": "",
        "name": "organisation",
        "placeholder": ""
      },
      domProps: {
        "value": (orgReq.abn)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(orgReq, "abn", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('label', [_vm._v("Pending for Approval (#" + _vm._s(orgReq.id) + ")")])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-licensing",
      "role": "tabpanel",
      "aria-labelledby": "pills-licensing-tab"
    }
  }, [_c('ApplicationDashTable', {
    ref: "applications_table",
    attrs: {
      "level": "internal",
      "url": _vm.applications_url
    }
  }), _vm._v(" "), _c('LicenceDashTable', {
    ref: "licences_table",
    attrs: {
      "level": "internal",
      "url": _vm.licences_url
    }
  }), _vm._v(" "), _c('ReturnDashTable', {
    ref: "returns_table",
    attrs: {
      "level": "internal",
      "url": _vm.returns_url
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "pills-compliance",
      "role": "tabpanel",
      "aria-labelledby": "pills-compliance-tab"
    }
  }, [(_vm.user.id) ? _c('SanctionOutcomePersonOrgDashTable', {
    ref: "sanction_outcome_person_org_table",
    attrs: {
      "level": "internal",
      "entity_id": _vm.user.id,
      "entity_type": "person"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.id) ? _c('LegalCasePersonOrgDashTable', {
    ref: "legal_case_person_org_table",
    attrs: {
      "level": "internal",
      "entity_id": _vm.user.id,
      "entity_type": "person"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.id) ? _c('IntelligenceInformation', {
    ref: "intelligence_information",
    attrs: {
      "entity_id": _vm.user.id,
      "entity_type": "person"
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav nav-pills mb-3",
    attrs: {
      "id": "pills-tab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "id": "pills-details-tab",
      "data-toggle": "pill",
      "href": "#pills-details",
      "role": "tab",
      "aria-controls": "pills-details",
      "aria-selected": "true"
    }
  }, [_vm._v("\n                        Details\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "pills-licensing-tab",
      "data-toggle": "pill",
      "href": "#pills-licensing",
      "role": "tab",
      "aria-controls": "pills-licensing",
      "aria-selected": "false"
    }
  }, [_vm._v("\n                        Licensing\n                    ")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "id": "pills-compliance-tab",
      "data-toggle": "pill",
      "href": "#pills-compliance",
      "role": "tab",
      "aria-controls": "pills-compliance",
      "aria-selected": "false"
    }
  }, [_vm._v("\n                        Compliance\n                    ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66bc6a80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/users/manage.vue
// module id = 999
// module chunks = 0